<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
            <a routerLink="/company" style="color: #003E53;">Company</a>
        </li>

        <li class="breadcrumb-item">
            <a style="color: #003E53;">Sample Forwarded</a>
        </li>

    </ol>
</nav>

<div class="row compact-content">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row gx-3">
                <div class="col-md-6 col-12 mb-2 mb-md-0 py-2">
                    <h5 class="mb-0 text-dark fw-bold">
                        <span style="color:#003E53">{{ sampleData?.name }}</span>
                        sample forwarded by
                        <span style="color:#003E53">{{ singleDistributor.name }}</span>
                    </h5>

                    <div class="d-flex flex-wrap justify-content-md-start mt-1 gap-2">
                        @if(singleDistributor?.email) {
                        <a class="text-muted small text-decoration-none d-flex align-items-center">
                            <i class="bi bi-envelope me-1 fs-7"></i>
                            <span class="text-truncate" style="max-width: 140px;">{{ singleDistributor.email }}</span>
                        </a>
                        }
                        @if(singleDistributor?.phone) {
                        <a class="text-muted small text-decoration-none d-flex align-items-center">
                            <i class="bi bi-telephone me-2 fs-7"></i>
                            {{ singleDistributor.phone }}
                        </a>
                        }
                    </div>
                </div>

                <div class="col-md-6 col-12">
                    <div class="d-flex justify-content-md-end align-items-center gap-3 flex-wrap">
                        <div class="flex-grow-1 text-md-end text-start">
                            <h5 class="fw-semibold mb-1 text-dark">
                                {{ sampleData?.name || 'Sample' }}
                            </h5>

                            @if(sampleData?.categoryId?.name) {
                            <div class="text-muted small d-flex align-items-center justify-content-md-end">
                                <i class="bi bi-tags me-1 fs-7"></i>
                                <span>{{ sampleData.categoryId.name }}</span>
                            </div>
                            }
                        </div>
                    </div>

                </div>
            </div>

            <hr class="m-0 p-o">
            <hr class="m-0 p-o">

            <div class="row">
                <div class="col-lg-4 mt-1 ">
                    <div class="">
                        <ng-select [(ngModel)]="selectedRecipientType" (change)="onRecipientChange($event)"
                            placeholder="Select Recipient Type" class="text-dark">
                            @if(distributorType==1){
                            <ng-option value='Wholesaler'>Wholesaler</ng-option>
                            <ng-option value='Retailer'>Retailer</ng-option>
                            }

                            <ng-option value='Customer'>Customer</ng-option>
                        </ng-select>
                    </div>
                </div>


                <div class="col-lg-4">
                    <mat-form-field mappearance="outline" class="w-100">
                        <mat-label>Search By Address</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.citySate" name="name"
                            (input)="onCityStateInputChange($event)">
                    </mat-form-field>
                </div>
                <div class="col-lg-4">
                    <mat-form-field class="w-100" (click)="picker.open()">
                        <mat-label>Search By Issue Date</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start" [(ngModel)]="sampleSearch.startdate" readonly />
                            <input matEndDate placeholder="End" [(ngModel)]="sampleSearch.enddate"
                                (dateChange)="sampleFilter($event)" readonly />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        @if (sampleSearch.startdate || sampleSearch.enddate) {
                        <mat-icon matSuffix (click)="clearDateRange()" class="clear-icon fs-7"
                            style="cursor: pointer;">close</mat-icon>
                        }
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>

            @if(selectedRecipientType=='Wholesaler'|| selectedRecipientType=='Retailer'){
            <ng-container>
                <div class="table-responsive ">
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="issuedSamplesToDistributorsDataSource"
                            class="table-bordered compact-table">

                            <ng-container matColumnDef="srno">
                                <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                                <td mat-cell *matCellDef="let row; let index = index">
                                    {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> Name </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap">
                                    {{element.receiverDistributorId?.name}} </td>
                            </ng-container>
                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef class=""> Email </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.receiverDistributorId?.email}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="phone">
                                <th mat-header-cell *matHeaderCellDef class=""> Phone </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.receiverDistributorId?.phone}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="cityState">
                                <th mat-header-cell *matHeaderCellDef class=""> City/State </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.city}},
                                    {{element.state}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="quantityAssigned">
                                <th mat-header-cell *matHeaderCellDef class=""> Assigned </th>
                                <td mat-cell *matCellDef="let element"> {{element.quantityAssigned}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="quantityRemaining">
                                <th mat-header-cell *matHeaderCellDef class="">Remaining </th>
                                <td mat-cell *matCellDef="let element"> {{element.quantityRemaining}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="distributorLimit">
                                <th mat-header-cell *matHeaderCellDef class=""> Limit </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element?.distributorLimit}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="issuedOn">
                                <th mat-header-cell *matHeaderCellDef class="">Issued On </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element?.createdAt |date}}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="issuedSamplesToDistributorsDisplayedColumns"
                                class="t_head"></tr>
                            <tr mat-row *matRowDef="let row; columns: issuedSamplesToDistributorsDisplayedColumns;">
                            </tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center"
                                    [attr.colspan]="issuedSamplesToDistributorsDisplayedColumns.length">
                                    No data available
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                    (page)="issuedSamplesToDistributors($event)">
                </mat-paginator>
            </ng-container>
            }

            @else {
            <ng-container>
                <div class="table-responsive">
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="issuedSamplesToDistributorsDataSource"
                            class="table-bordered compact-table">

                            <ng-container matColumnDef="srno">
                                <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                                <td mat-cell *matCellDef="let row; let index = index">
                                    {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                                </td>
                            </ng-container>
                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> Name </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap">
                                    {{element.customerId?.name}} </td>
                            </ng-container>
                            <ng-container matColumnDef="gender">
                                <th mat-header-cell *matHeaderCellDef class=""> Gender </th>
                                <td mat-cell *matCellDef="let element">
                                    @if (element?.customerId?.gender == 1) {
                                    Male
                                    } @else if (element?.customerId?.gender == 2) {
                                    Female
                                    } @else if (element?.customerId?.gender == 3) {
                                    Other
                                    } @else {
                                    <span class="text-muted">Not updated</span>
                                    }
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="dob">
                                <th mat-header-cell *matHeaderCellDef class=""> Age </th>
                                <td mat-cell *matCellDef="let element">

                                    @if (element?.customerId?.dob) {
                                    {{ calculateAge(element.customerId?.dob) }}
                                    } @else {
                                    <span class="text-muted">Not updated</span>
                                    }
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="state">
                                <th mat-header-cell *matHeaderCellDef class=""> State </th>
                                <td mat-cell *matCellDef="let element"> {{element.customerId?.state}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="city">
                                <th mat-header-cell *matHeaderCellDef class=""> City </th>
                                <td mat-cell *matCellDef="let element"> {{element.customerId?.city}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef class=""> Address </th>
                                <td mat-cell *matCellDef="let element"> {{element.customerId?.address}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="issuedQuantity">
                                <th mat-header-cell *matHeaderCellDef class=""> issuedQuantity </th>
                                <td mat-cell *matCellDef="let element"> {{element.issuedQuantity}}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="issuedSamplesToCustomersDisplayedColumns"
                                class="t_head"></tr>
                            <tr mat-row *matRowDef="let row; columns: issuedSamplesToCustomersDisplayedColumns;">
                            </tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center"
                                    [attr.colspan]="issuedSamplesToCustomersDisplayedColumns.length">
                                    No data available
                                </td>
                            </tr>

                        </table>
                    </div>
                </div>

                <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                    (page)="issuedSamplesToDistributors($event)">
                </mat-paginator>
            </ng-container>
            }

        </app-card>
    </div>
</div>


